import React from 'react'

import {ListItem} from '@vio/atlas/ListItem'
import {FormattedMessageWrapper} from '@vio/core/src/localization/components/FormattedMessage'

import {useIsSaveFraming} from '../../../priceWatch/hooks/useIsSaveFraming'
import {
  MyListLinkComponent,
  useTrackMyListLinkClick
} from '../../../priceWatch/hooks/useTrackMyListLinkClick'
import {myListMessages} from '../../../priceWatch/myListMessages'

interface Props {
  /** Url of users account page */
  accountUrl?: string
  /** Url of users alerts page */
  alertsUrl?: string
  /** Url of users bookings page */
  myBookingsUrl?: string
  /** Slot rendered above the Sign out item (e.g. Get The App link) */
  getTheAppSlot?: React.ReactNode
  /** Callback fired when the user clicks the Sign out item */
  onLogOut?: () => void
  isAuthenticated: boolean
}

/**
 * The list of menu items rendered inside the user popover.
 *
 * Shared by the standard header widget and the white-label header widgets.
 */
export const AuthenticatedMenuItems = ({
  accountUrl,
  alertsUrl,
  myBookingsUrl,
  getTheAppSlot,
  onLogOut,
  isAuthenticated
}: Props) => {
  const saveFramingIsOn = useIsSaveFraming()
  const trackAlertsClick = useTrackMyListLinkClick({
    component: MyListLinkComponent.UserMenu,
    isAuthenticated,
    href: alertsUrl
  })

  return (
    <>
      {accountUrl && (
        <ListItem
          as="link"
          href={accountUrl}
          title={
            <FormattedMessageWrapper
              dataId="AccountProfileLink"
              id="manageAccount"
              defaultMessage="Manage account"
            />
          }
        />
      )}
      {alertsUrl && (
        <ListItem
          as="link"
          href={alertsUrl}
          onClick={trackAlertsClick}
          title={
            saveFramingIsOn ? (
              <FormattedMessageWrapper
                dataId="AlertsLink"
                {...myListMessages.tabLabel}
              />
            ) : (
              <FormattedMessageWrapper
                dataId="AlertsLink"
                id="priceAlertTabLink"
                defaultMessage="Alerts"
              />
            )
          }
        />
      )}
      {myBookingsUrl && (
        <ListItem
          as="link"
          href={myBookingsUrl}
          title={
            <FormattedMessageWrapper
              dataId="MyBookingsPageLink"
              id="myBookings"
              defaultMessage="My bookings"
            />
          }
        />
      )}
      {getTheAppSlot}
      {onLogOut && (
        <ListItem
          as="button"
          onClick={onLogOut}
          title={
            <FormattedMessageWrapper
              dataId="LogOutProfileLink"
              id="signOut"
              defaultMessage="Sign out"
            />
          }
        />
      )}
    </>
  )
}
